export default __webpack_public_path__ + "static/media/c3.d90c7e24.png";